'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _redboxReact = require('redbox-react');

var _redboxReact2 = _interopRequireDefault(_redboxReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function render(markup, el) {
  try {
    _reactDom2.default.render(markup, el);
  } catch (e) {
    _reactDom2.default.render(_react2.default.createElement(_redboxReact2.default, { error: e }), el);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-snapshot-render/lib/index.js
// module id = 503
// module chunks = 2